const DAYS_FR = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
const MONTHS_FR = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

export function formatNextOpen(dayOffset: number, dayIndex: number, openTime: string, now: Date): string {
  if (dayOffset === 0) return `Ouvre à ${openTime}`;
  if (dayOffset === 1) return `Ouvre demain à ${openTime}`;
  if (dayOffset <= 7) return `Ouvre ${DAYS_FR[dayIndex]} à ${openTime}`;

  const target = new Date(now);
  target.setDate(now.getDate() + dayOffset);
  return `Ouvre ${DAYS_FR[dayIndex]} ${target.getDate()} ${MONTHS_FR[target.getMonth()]} à ${openTime}`;
}
